/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|components|LoginToViewPricing'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-LoginToViewPricing' */
                'partner/components/LoginToViewPricing.component.tsx'),
            cn: '__local__-__local__-LoginToViewPricing'
        };
componentDictionary['__local__|__local__|modules|ari-search-results|components|AriSearchResultTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriSearchResultTable' */
                'partner/modules/ari-search-results/components/AriSearchResultTable.component.tsx'),
            cn: '__local__-__local__-AriSearchResultTable'
        };
componentDictionary['__local__|__local__|modules|education-training|components|CourseTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-CourseTable' */
                'partner/modules/education-training/components/CourseTable.component.tsx'),
            cn: '__local__-__local__-CourseTable'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|AriHotspotImage'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriHotspotImage' */
                'partner/modules/model-viewer/components/AriHotspotImage.component.tsx'),
            cn: '__local__-__local__-AriHotspotImage'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|AriPartsListTable'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-AriPartsListTable' */
                'partner/modules/model-viewer/components/AriPartsListTable.component.tsx'),
            cn: '__local__-__local__-AriPartsListTable'
        };
componentDictionary['__local__|__local__|modules|model-viewer|components|assemblyDropdown'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-assemblyDropdown' */
                'partner/modules/model-viewer/components/assemblyDropdown.component.tsx'),
            cn: '__local__-__local__-assemblyDropdown'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|addToCart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addToCart' */
                'partner/themes/gardner-theme-b2c/views/components/addToCart.component.tsx'),
            cn: '__local__-__local__-addToCart'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/gardner-theme-b2c/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/gardner-theme-b2c/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|create-order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-create-order-template' */
                'partner/themes/gardner-theme-b2c/views/components/create-order-template.component.tsx'),
            cn: '__local__-__local__-create-order-template'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/gardner-theme-b2c/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/gardner-theme-b2c/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|themes|gardner-theme-b2c|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promocode' */
                'partner/themes/gardner-theme-b2c/views/components/promocode.component.tsx'),
            cn: '__local__-__local__-promocode'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|addToCart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addToCart' */
                'partner/themes/gardner-theme/views/components/addToCart.component.tsx'),
            cn: '__local__-__local__-addToCart'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/gardner-theme/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/gardner-theme/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|create-order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-create-order-template' */
                'partner/themes/gardner-theme/views/components/create-order-template.component.tsx'),
            cn: '__local__-__local__-create-order-template'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/gardner-theme/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/gardner-theme/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|themes|gardner-theme|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promocode' */
                'partner/themes/gardner-theme/views/components/promocode.component.tsx'),
            cn: '__local__-__local__-promocode'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-product' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
        };